// iter 149 / 150 - Dispatcher for /find-a-professional/:slug.
//
// React Router v6 doesn't differentiate between a city slug
// (`mexico-city`) and a partner UUID (`eebc35ae-…`) by route shape
// alone. This component inspects the segment at runtime:
//
// - Known city slug → render the city-scoped FindAProfessional listing.
// - Anything else (UUID, garbage)  → iter 150 redirects to the
//   gated portal partner profile via /start (lead-capture funnel).
//   The public profile page (PublicPartnerProfile.js) was removed in
//   iter 150 - full profiles are members-only.

import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import FindAProfessional, { FAP_CITY_MAP } from './FindAProfessional';

const FindAProfessionalDispatcher = () => {
  const { slug } = useParams();
  if (slug && Object.prototype.hasOwnProperty.call(FAP_CITY_MAP, slug)) {
    return <FindAProfessional citySlug={slug} />;
  }
  // Treat as partner ID - route through /start to gate behind login.
  // /start hands the user off to /portal/partners/{id} on completion.
  const target = encodeURIComponent(`/portal/partners/${slug || ''}`);
  return <Navigate to={`/start?return=${target}`} replace />;
};

export default FindAProfessionalDispatcher;
